import * as FPT from '../utility/fpt';
import { getChildren } from './domUtils';

function trackReportLink() {
  FPT.trackLinkClick('reportInappropriateContent');
}

export function addTrackReportLink() {
  getChildren('.help_security')[2].addEventListener('click', trackReportLink);
}

export function removeTrackReportLink() {
  getChildren('.help_security')[2].removeEventListener(
    'click',
    trackReportLink
  );
}
